// extracted by mini-css-extract-plugin
export default {"callout":"new_callout__r6HFM","whitetext":"new_whitetext__b6ONe"};